import { Thought } from "@/interfaces/copilotTypes";
import React from "react";
import ThoughtGroup from "./ThoughtGroup";

function ThoughtChain({ thought }: { thought: Thought }) {
  return (
    <div>
      {thought.groups.map((group) => (
        <ThoughtGroup key={group._id} group={group} />
      ))}
    </div>
  );
}

export default ThoughtChain;
